module.exports = __webpack_public_path__ + "img/logo.b3ab4c0c.png";